import { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login, error } = useAuth();
  const [chatId, setChatId] = useState('');
  const [loading, setLoading] = useState(false);

  // Get Telegram WebApp data if available
  const telegram = (window as any).Telegram?.WebApp;
  const initData = telegram?.initDataUnsafe;

  const handleTelegramLogin = async () => {
    if (initData?.user) {
      const userId = initData.user.id;
      localStorage.setItem('chat_id', String(userId));
      await login(userId);
    }
  };

  // Auto-login with Telegram
  if (telegram) {
    if (!initData?.user) {
      return (
        <div className="login-container">
          <h1 className="login-title">TaskMate</h1>
          <p className="login-subtitle">Откройте приложение через Telegram</p>
          <button className="btn btn-primary" onClick={() => telegram.expand()}>
            Открыть в Telegram
          </button>
        </div>
      );
    }

    // Auto-authenticate with Telegram
    if (!localStorage.getItem('chat_id')) {
      handleTelegramLogin();
      return (
        <div className="loading">
          <div className="spinner"></div>
        </div>
      );
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!chatId) return;

    setLoading(true);
    await login(parseInt(chatId, 10));
    setLoading(false);
  };

  return (
    <div className="login-container">
      <h1 className="login-title">TaskMate</h1>
      <p className="login-subtitle">Система управления задачами</p>

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: '300px' }}>
        <div className="form-group">
          <label className="form-label">Telegram Chat ID</label>
          <input
            type="text"
            className="form-input"
            value={chatId}
            onChange={(e) => setChatId(e.target.value)}
            placeholder="Введите ваш Telegram ID"
          />
        </div>
        <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
          {loading ? 'Вход...' : 'Войти'}
        </button>
      </form>

      <p style={{ marginTop: '2rem', fontSize: '0.875rem', color: 'var(--gray-500)' }}>
        Для получения Chat ID напишите боту /myid
      </p>
    </div>
  );
}
